import Client from './AllPublicMethods'
export { PublicError as Error } from './Error'

export const client = new Client()
